/**
 * お知らせ一括既読
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/notifications/bulk_reads`

const notifications_bulk_reads = {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        create({ commit }) {
            return new Promise((resolve) => {
                Vue.$http.post(API_PATH).then(data => {
                    commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
                    resolve(data.content)
                })
            })
        },
    },
    mutations: {},

}

export default notifications_bulk_reads
